<!-- 日志查询 -->
<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: WUFAN
 * @Date: 2020-04-21
 * @LastEditors: WUFAN
 * @LastEditTime: 2020-04-21
 -->
<!--  -->
<template>
  <div>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      v-model="form"
      ref="crud"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @sort-change="sortChange"
      @on-load="onLoad"
      @refresh-change="refresh"
    >
      <!-- 状态栏目扩展  -->
      <template slot-scope="{type,size,row}" slot="menu">
        <el-button v-if="row.modifyType === 2" :type="type" :size="size" @click="VIEW(row)">详情</el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="修改详情"
      append-to-body
      v-dialogDrag
      :visible.sync="modifyDetails.show"
      width="40%"
      >
      <el-scrollbar  style="height:450px;padding:0px;">
       <el-table
        :data="modifyDetails.tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="prop"
          label="字段名">
        </el-table-column>
        <el-table-column
          prop="oldVal"
          label="原值">
        </el-table-column>
       <el-table-column
          prop="newVal"
          label="新值">
        </el-table-column>
      </el-table>
      </el-scrollbar>
    </el-dialog>

  </div>
</template>

<script>
const format = 'yyyy-MM-dd HH:mm:ss'
export default {
  name: 'BlackAndWhiteListManage',
  data() {
    return {
      modifyDetails: {
        show: false,
        tableData: []
      },
      form: {},
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        dialogWidth: 1000,
        dialogHeight: 400,
        searchMenuSpan: 8,
        align: 'center',
        tip: true,
        stripe: true,
        border: true,
        index: false,
        viewBtn: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        selection: false,
        menuWidth: 100,
        column: [
          {
            label: '账号ID',
            prop: 'accountId',
            searchSpan: 6,
            overHidden: true,
            hide: true
          }, {
            label: '操作类型',
            prop: 'modifyType',
            type: 'select',
            search: false,
            hide: true,
            dicData: [
              {
                label: '新增',
                value: 1
              },
              {
                label: '修改',
                value: 2
              },
              {
                label: '删除',
                value: 3
              }
            ]
          }, {
            label: '操作人',
            prop: 'auditUserName',
            overHidden: true
          }, {
            label: '操作时间',
            prop: 'auditTime',
            sortable: true
          }, {
            label: '操作IP',
            prop: 'ip'
          }, {
            label: '开始时间',
            prop: 'startTime',
            search: true,
            searchSpan: 8,
            hide: true,
            'type': 'datetime',
            format,
            'valueFormat': format,
            showColumn: false
          }, {
            label: '结束时间',
            prop: 'endTime',
            searchSpan: 8,
            search: true,
            hide: true,
            'type': 'datetime',
            format,
            'valueFormat': format,
            showColumn: false
          }
        ]
      },
      data: []

    }
  },

  components: {},

  mounted() {

  },
  methods: {

    refresh: function() {
      this.onLoad()
    },
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    searchChange(params, done) {
      for (let key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      done()
      this.page.currentPage = 1
      this.query = params
      this.onLoad()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      let orderItemList = []
      if (order.order) {
        orderItemList.push({
          asc: order.order === 'ascending',
          column: order.prop
        })
      } else {
        orderItemList.push({
          asc: false,
          column: 'auditTime'
        })
      }
      this.loading = true
      this.$http.post('/account-modify-audit/query/self', { 'entity': params, 'orderItemList': orderItemList }, { params: {
        startTime: this.query.startTime,
        endTime: this.query.endTime,
        pageNum: page.currentPage,
        pageSize: page.pageSize
      }}).then(
        response => {
          this.loading = false
          this.data = response.data.records
          this.page.total = response.data.total || response.data.records.length
        }
      ).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    VIEW(row) {
      try {
        this.modifyDetails.tableData = []
        let modifyFieds = row.modifyAttr.split(',')
        let originEntity = JSON.parse(row.originEntity) || {}
        let newEntity = JSON.parse(row.newEntity) || {}
        modifyFieds.forEach(item => {
          if (item && item !== 'userPassword') {
            this.modifyDetails.tableData.push({
              prop: item,
              oldVal: originEntity[item],
              newVal: newEntity[item]
            })
          }
        })
        if (this.modifyDetails.tableData.length) {
          this.modifyDetails.show = true
        } else {
          this.$message.error('该条记录可能为修改密码,无详情')
        }
      } catch (e) {
        this.$message.error('日志记录不完整,无法查看详情')
      }
    }

  }
}
</script>
<style lang='scss' scoped>
</style>

